import React from 'react';

type ShowingsCalendarHoverReadContextValue = {
  hoveredAppointment: string | null;
};

type ShowingsCalendarHoverWriteContextValue = {
  setHoveredAppointment: React.Dispatch<React.SetStateAction<string | null>>;
};

const ShowingsCalendarHoverReadContext = React.createContext<
  ShowingsCalendarHoverReadContextValue | undefined
>(undefined);

const ShowingsCalendarHoverWriteContext = React.createContext<
  ShowingsCalendarHoverWriteContextValue | undefined
>(undefined);

export const useReadCalendarHover = () => {
  const context = React.useContext(ShowingsCalendarHoverReadContext);
  if (context === undefined) {
    throw new Error(
      'useReadCalendarHover must be used within a ShowingsCalendarHoverContextProvider',
    );
  }
  return context;
};

export const useWriteCalendarHover = () => {
  const context = React.useContext(ShowingsCalendarHoverWriteContext);
  if (context === undefined) {
    throw new Error(
      'useWriteCalendarHover must be used within a ShowingsCalendarHoverContextProvider',
    );
  }
  return context;
};

export const ShowingsCalendarHoverContextProvider: React.FC = ({
  children,
}) => {
  const [hoveredAppointment, setHoveredAppointment] = React.useState<
    string | null
  >(null);

  return (
    <ShowingsCalendarHoverReadContext.Provider value={{ hoveredAppointment }}>
      <ShowingsCalendarHoverWriteContext.Provider
        value={{
          setHoveredAppointment,
        }}
      >
        {children}
      </ShowingsCalendarHoverWriteContext.Provider>
    </ShowingsCalendarHoverReadContext.Provider>
  );
};
